export const getCookie = (name) => {
    const nameEQ = name + '='
    if (typeof document !== 'undefined') {
        const ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) === ' ') c = c.substring(1, c.length)
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
        }
    }
    return null
}

export const setCookie = function (name, value, days) {
    if (days) {
        var currentDay = new Date()
        currentDay.setTime(currentDay.getTime() + days * 24 * 60 * 60 * 1000)
        // @ts-ignore
        var expires = '; expires=' + currentDay.toGMTString()
    } else expires = ''
    document.cookie = name + '=' + value + expires + '; path=/'
}

export const deleteCookie = (name: string) => {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}
export const resetUserCookies = () => {
    deleteCookie('PHPSESSID');
    deleteCookie('appliedXaloLeadCourse');
    deleteCookie('VNW_WS_COOKIE');
    deleteCookie('VNW_USER_COOKIE');
    deleteCookie('VNW128450527232960');
    deleteCookie('VNWWS128450527232960');
    deleteCookie('VNWISN128450527232960');
    deleteCookie("VNWJSAll128450527232960");
    deleteCookie('flo_vnw');
    deleteCookie('VNW94a08da1fecbb6e8b46990538c7b50b2');
    deleteCookie("VNWJSStoredKey");
}
